var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserManagementIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.431,
    height: 16.432,
    viewBox: "0 0 16.431 16.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-management-5660550",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8493",
    "data-name": "Group 8493",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9639",
    "data-name": "Path 9639",
    d: "M9.515,11.4a6.48,6.48,0,0,0-6.331,5.161.587.587,0,0,0,.577.695h9.327a.587.587,0,0,1,0,1.174H3.761a1.76,1.76,0,0,1-1.728-2.1.021.021,0,0,1,0-.006,7.678,7.678,0,0,1,4.948-5.666,4.7,4.7,0,1,1,5.067,0,7.592,7.592,0,0,1,1.337.625.587.587,0,0,1-.6,1.01A6.412,6.412,0,0,0,9.515,11.4Zm0-1.174A3.528,3.528,0,1,0,5.988,6.7,3.531,3.531,0,0,0,9.515,10.229Zm5.4,5.269H13.15a.587.587,0,0,1,0-1.174h1.761V12.563a.587.587,0,0,1,1.174,0v1.761h1.761a.587.587,0,0,1,0,1.174H16.084v1.761a.587.587,0,0,1-1.174,0Z",
    transform: "translate(-2 -2)",
    fill: "#a3e3d9",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementIconLight);
export default __webpack_public_path__ + "static/media/user-management-icon-light.088d8948cfc524773d4521a25ff9853a.svg";
export { ForwardRef as ReactComponent };